var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRainbow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 261,
    viewBox: "0 0 255 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.00140381 223.299C120.714 223.299 218.572 123.324 218.572 -0.000213623H255C255 143.879 140.833 260.515 0.00140381 260.515V223.299Z",
    fill: "#008F8D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.15527e-05 148.871C80.476 148.871 145.713 82.2218 145.713 0.004776H182.142C182.142 102.776 100.594 186.087 9.15527e-05 186.087V148.871Z",
    fill: "#245099"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.001297 74.4375C40.2401 74.4375 72.8592 41.1127 72.8592 0.00341797H109.287C109.287 61.6658 60.3579 111.653 0.001297 111.653V74.4375Z",
    fill: "#E4006F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRainbow);
export default __webpack_public_path__ + "static/media/rainbow.80f337c2c3eaa2aa438fc7729f507f5a.svg";
export { ForwardRef as ReactComponent };